import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from 'common/utils/ErrorMessage';
import WarningMessage from 'common/utils/WarningMessage';

const DateValidationMessages = ({
  canInvoiceAboveRemainingAuthorizedAmount,
  feeScheduleProgramName,
  hasSelectedDate,
  ignoreSocialCareExpiredDates,
  insuranceDateNonValid,
  insuranceExpired,
  requestedDatesNonValid,
}) => (
  <>
    {requestedDatesNonValid && (
      <div className="col-span-5 px-0 flex space-x-2 -mt-6 mb-8">
        <ErrorMessage>
          {canInvoiceAboveRemainingAuthorizedAmount ?
            'The selected service delivery dates fall outside the authorized service delivery dates. ' +
            'Please check that the correct dates are selected prior to submitting.' :
            'This contracted service cannot be submitted ' +
            'because the selected service delivery dates fall outside the authorized service delivery dates.'}
        </ErrorMessage>
      </div>
    )}
    {!ignoreSocialCareExpiredDates && insuranceDateNonValid && hasSelectedDate && (
      <div className="col-span-5 px-0 flex space-x-2 -mt-6 mb-8">
        <ErrorMessage>
          Client must be enrolled in a social insurance plan
          with the {feeScheduleProgramName} contracted program during the selected service dates.
        </ErrorMessage>
      </div>
    )}
    {ignoreSocialCareExpiredDates && hasSelectedDate && insuranceDateNonValid && (
      <div className="col-span-5 px-0 flex space-x-2 -mt-6 mb-8">
        <ErrorMessage>
          The selected service dates cannot be prior to the client&apos;s social care coverage enrollment start date.
        </ErrorMessage>
      </div>
    )}
    {ignoreSocialCareExpiredDates && hasSelectedDate && insuranceExpired && (
      <div className="col-span-5 px-0 flex space-x-2 -mt-6 mb-8">
        <WarningMessage>
          The client&apos;s social care coverage ended prior to or during the selected service delivery date(s).
          Please verify the service date(s) before submitting.
        </WarningMessage>
      </div>
    )}
  </>
);

DateValidationMessages.propTypes = {
  canInvoiceAboveRemainingAuthorizedAmount: PropTypes.bool.isRequired,
  feeScheduleProgramName: PropTypes.string.isRequired,
  hasSelectedDate: PropTypes.bool.isRequired,
  ignoreSocialCareExpiredDates: PropTypes.bool.isRequired,
  insuranceDateNonValid: PropTypes.bool.isRequired,
  insuranceExpired: PropTypes.bool.isRequired,
  requestedDatesNonValid: PropTypes.bool.isRequired,
};

export default DateValidationMessages;
